// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { Modal } from 'react-bootstrap';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { closeReportUserModal } from '../../actions/modalActions';

// Components
import ReportUserForm from '../ReportUserForm';

// Translation
import { FormattedMessage } from 'react-intl';

// Locale
import messages from '../../locale/jsonMessages';
import s from './ReportUserModal.css';

const ReportUserModal = ({ profileId }) => {

    const reportModal = useSelector(state => state.modalStatus.isReportUserModalOpen);
    const reporterId = useSelector(state => state.account && state.account.data && state.account.data.userId);
    const reporterName = useSelector(state => state.account && state.account.data && state.account.data.firstName);
    const adminEmail = useSelector(state => state.siteSettings.data.email);

    const dispatch = useDispatch();

    let initialValues = {};

    initialValues = {
        reporterId,
        profileId,
        reportType: '',
        reporterName,
        adminEmail
    }

    return (
        <Modal
            show={reportModal}
            animation={false}
            onHide={() => dispatch(closeReportUserModal())}
            dialogClassName={cx('commonModalContainer', 'globalModalContainer')}>
            <Modal.Header closeButton className='commonModalHeader'>
                <Modal.Title className='commonModalTitle'>
                    <FormattedMessage {...messages.anonymousMessage} />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body bsClass='commonModalBody'>
                <ReportUserForm initialValues={initialValues} />
            </Modal.Body>
        </Modal>
    );
}

ReportUserModal.propTypes = {
    closeLoginModal: PropTypes.any,
    reportModal: PropTypes.bool,
    closeReportUserModal: PropTypes.any,
    formatMessage: PropTypes.any,
};
export default withStyles(s)(ReportUserModal);
